import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { Mesh, BufferAttribute, LineSegments } from 'three';

export class Merger{
	constructor() {
	}

	merge( scene ) {

		let { mesh, line, children } = this._getMergedObjects( scene );

		//remove children
		children.forEach( child => child.parent.remove( child ) );

		//add mesh
		if( mesh ) scene.add( mesh );

		//add LineSegments
		if( line ) scene.add( line );

		return mesh;
	}

	_getMergedObjects( scene ) {

		let { mesh, line, children } = this._getMergedGeometry( scene );

		const m = mesh.geometry ? new Mesh( mesh.geometry, mesh.materials ) : null;
		const l = line.geometry ? new LineSegments( line.geometry, line.materials ) : null;

		return { mesh: m, line: l, children: children };
	}

	_getMergedGeometry( scene, mergeMaterials = true ) {
		let geo_meshes = [];
		let geo_lines = [];
		let material_meshes = [];
		let material_lines = [];
		let children = [];
		scene.traverse( child => {
			if( !(child.isMesh || child.isLineSegments || child.isLine) ) return;

			//force update matrix
			child.updateWorldMatrix ( true, false );

			//get geometry
			let geometry = child.geometry.index === null ? child.geometry.clone() : child.geometry.clone().toNonIndexed();

			//if normal-s not presented add
			if(typeof geometry.attributes.normal === 'undefined') {
				geometry.computeVertexNormals();
			}

			//if uv-s not presented add
			if(typeof geometry.attributes.uv === 'undefined') {
				let uv = new BufferAttribute( new Float32Array( geometry.attributes.position.count * 2 ), 2 );
				geometry.setAttribute( 'uv', uv );
			}

			//if uvs itemSize 3 fix it to 2
			if( geometry.attributes.uv.itemSize > 2 ) {
				let uv = new BufferAttribute( new Float32Array( geometry.attributes.uv.count * 2 ), 2 );
				for (let i = 0; i < geometry.attributes.uv.count; i++) {
					uv.set(geometry.attributes.uv.getX(i), i * 2);
					uv.set(geometry.attributes.uv.getY(i), i * 2 + 1);
				}
				geometry.deleteAttribute( 'uv' );
				geometry.setAttribute( 'uv', uv );
			}

			//get geometry
			if( child.isMesh )
			    geo_meshes.push( geometry.applyMatrix4( child.matrixWorld ) );
			else
				geo_lines.push( geometry.applyMatrix4( child.matrixWorld ) );

			//get materials
			if( mergeMaterials ) {
				if( child.isMesh )
					material_meshes.push( child.material );
				else
					material_lines.push( child.material );
			}

			//save children
			children.push( child );
		} );

		//merge geometry
		let geo_mesh = geo_meshes.length > 0 ? BufferGeometryUtils.mergeGeometries( geo_meshes, mergeMaterials ) : null;
		let geo_line = geo_lines.length > 0 ? BufferGeometryUtils.mergeGeometries( geo_lines, mergeMaterials ) : null;

		return {
			mesh: {
				geometry: geo_mesh,
				materials: material_meshes
			},
			line: {
				geometry: geo_line,
				materials: material_lines
			},
			children: children
		};
	}
}